import React, { useState, useEffect, useCallback, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";

import { DisplayPDF } from "../displayPDF/displayPDF";

import {
    setFiltro,
    carregarGraficos,
    getDemanda,
    getDemandaContagem,
    getListaCliente,
    getListaUnidadeConsumidora,
    getListaDemandaContratoTipo,
    excluirAgendamento,
    excluirPeriodoTeste,
    setAguardando,
} from "./dashboardActions";
import { getListaSelect as getListaEmpresa } from "../empresa/empresaActions";
import { convertToBase64 } from "../utils/convertToBase64.js";

import { getTotalFaturasImportadas, buscarPdf } from "../fatura/faturaActions";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { getTotalUsuarios, getLogados } from "../usuario/usuarioActions";
import { Loading } from "../common/loading/loading";
import { setPeriodoTesteVisualizado } from "../demandaContrato/demandaContratoActions";

import { ModalLogadosSemana } from "./components/modalLogadosSemana";
import { ModalLogados } from "./components/modalLogados";
import { TabelaAproveitamentoHorario } from "./components/tabelaAproveitamentoHorario";
import { TabelaContratoDemanda } from "./components/tabelaContratosDemanda";
import { GraficoCustoAnual } from "./components/graficoCustoAnual";
import { Filtros } from "./components/filtros";
import { CardsTotalizadores } from "./components/cardsTotalizadores";
import { GraficoCustoUnidadeUltimoMes } from "./components/graficoCustoUnidadeUltimoMes";
import { GraficoCustoPorUnidadeAcumuladoAno } from "./components/graficoCustoPorUnidadeAcumuladoAno";
import { CardAvatar } from "./components/cardAvatar";
import { gerarRelatorio } from "../fatura/faturaActions.js";

function Dashboard(props) {
    const contentCardRef = useRef(null);
    const [state, setState] = useState({
        dialogLogados: false,
        dialogLogadosSemana: false,
    });

    if (!props.usuarioLogado) return <></>;

    useEffect(() => {
        props.getListaEmpresa();
        props.getListaDemandaContratoTipo();

        const novoFiltro = { ...props.filtro };
        let alterou = false;

        if (novoFiltro.id_empresa == null && props.usuarioLogado.id_empresa) {
            novoFiltro.id_empresa = props.usuarioLogado.id_empresa;
            alterou = true;
        }

        if (novoFiltro.id_cliente == null && props.usuarioLogado.id_cliente) {
            novoFiltro.id_cliente = props.usuarioLogado.id_cliente;
            alterou = true;
        }
        if (alterou) props.setFiltro(novoFiltro);
    }, []);

    useEffect(() => {
        props.carregarGraficos();
    }, [props.filtro]);

    useEffect(() => {
        //traz totalizadores apenas considerando a empresa do usuário logado, ou caso seja um root, mostra de todas empresas
        const idEmpresa = props.usuarioLogado.id_empresa || props.filtro.id_empresa;
        props.getListaCliente(idEmpresa);
        props.getListaUnidadeConsumidora(idEmpresa);
        props.getTotalUsuarios(idEmpresa);
        props.getLogados({ callback: null, idEmpresa });
        props.getTotalFaturasImportadas(idEmpresa);
        props.getDemandaContagem();
    }, [props.filtro.id_empresa]);

    const atualizarStatePai = useCallback((novosValores) => setState((prev) => ({ ...prev, ...novosValores })), []);

    if (props.pdf) {
        return <DisplayPDF closePdf={props.setArquivoPDF} pdfBase64={props.pdf} nomePdf={props.nomePdf} />;
    }

    const listaUCsCliente = props.listaUnidadeConsumidora.filter((uc) => uc.id_cliente == props.filtro.id_cliente);
    const listaUCsGrupoA = listaUCsCliente.filter((uc) => [1, 4].includes(uc.id_grupo_faturamento));
    const listaUCsGrupoAouIrrigante = listaUCsCliente.filter((uc) => [1, 4].includes(uc.id_grupo_faturamento) || uc.irrigante);

    const exibirAproveitamentoHorario = !!(props.usuarioLogado.administrador || listaUCsGrupoAouIrrigante.length);
    const exibirContratosDemanda = !!(props.usuarioLogado.administrador || listaUCsGrupoA.length);

    return (
        <div ref={contentCardRef}>
            {props.aguardando ? <Loading /> : null}
            {state.dialogLogados ? <ModalLogados listaLogados={props.listaLogados} handleClose={() => setState({ ...state, dialogLogados: false })} /> : null}
            {state.dialogLogadosSemana ? <ModalLogadosSemana listaLogados={props.listaLogados} handleClose={() => setState({ ...state, dialogLogadosSemana: false })} /> : null}

            <Content>
                <ContentCard>
                    <ContentCardHeader>
                        <Filtros
                            usuarioLogado={props.usuarioLogado}
                            listaEmpresa={props.listaEmpresa}
                            listaCliente={props.listaCliente}
                            listaMesBase={props.listaMesBase}
                            filtro={props.filtro}
                            setFiltro={props.setFiltro}
                        />
                        <CardsTotalizadores atualizarStatePai={atualizarStatePai} />
                    </ContentCardHeader>
                </ContentCard>

                <Row>
                    <Grid cols="12 12 12 8">
                        <GraficoCustoUnidadeUltimoMes
                            filtro={props.filtro}
                            listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                            listaGraficoCustoPorUnidadeAcumuladoAno={props.listaGraficoCustoPorUnidadeAcumuladoAno}
                            listaGraficoCustoUnidadeUltimoMes={props.listaGraficoCustoUnidadeUltimoMes}
                            buscarPdf={props.buscarPdf}
                            setArquivoPDF={props.setArquivoPDF}
                        />
                    </Grid>
                    {window.innerWidth >= 962 && (
                        <Grid cols="12 12 12 4" style={{ display: "flex", flexDirection: "column" }}>
                            <CardAvatar />
                        </Grid>
                    )}
                </Row>
                <Row>
                    <Grid cols="12 12 12 8">
                        <GraficoCustoAnual listaGraficoCustoAnual={props.listaGraficoCustoAnual} />
                    </Grid>
                    <Grid cols="12 12 12 4" style={{ display: "flex", flexDirection: "column" }}>
                        <GraficoCustoPorUnidadeAcumuladoAno
                            listaGraficoCustoPorUnidadeAcumuladoAno={props.listaGraficoCustoPorUnidadeAcumuladoAno}
                            listaGraficoCustoAnual={props.listaGraficoCustoAnual}
                        />
                    </Grid>
                </Row>
                {exibirAproveitamentoHorario && (
                    <TabelaAproveitamentoHorario filtro={props.filtro} listaConsumoPercentualPorHorarioUltimoMes={props.listaConsumoPercentualPorHorarioUltimoMes} />
                )}
                {exibirContratosDemanda && (
                    <TabelaContratoDemanda
                        filtro={props.filtro}
                        listaDemandaContratoTipo={props.listaDemandaContratoTipo}
                        listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                        handleChangeFiltroTipoContrato={(id_tipo_contrato_demanda) => {
                            props.setFiltro({ ...props.filtro, id_tipo_contrato_demanda });
                            props.getDemandaContagem();
                        }}
                        usuarioLogado={props.usuarioLogado}
                        listaDemandaContagem={props.listaDemandaContagem}
                        handleClickTooltipPeriodoTeste={(item) => {
                            props.setPeriodoTesteVisualizado({ id: item.id });
                            props.getDemandaContagem();
                        }}
                        handleExcluirPeriodoTeste={(item) => {
                            props.excluirPeriodoTeste({ id: item.id });
                            props.getDemandaContagem();
                        }}
                        handleExcluirAgendamento={({ agendamentoDemanda, mesAgendamento, anoAgendamento }) => {
                            props.excluirAgendamento({ id: agendamentoDemanda.id, competencia_agendamento: mesAgendamento + "/" + anoAgendamento });
                            props.getDemandaContagem();
                        }}
                        handleExport={handleExport}
                    />
                )}
            </Content>
        </div>
    );

    async function handleExport(propsExport) {
        try {
            const getTamanhoBase = () => {
                const zoomAtual = Math.floor(window.devicePixelRatio * 100);
                let tamanhoBase = 1750;
                if (window.innerWidth >= 768) {
                    if (zoomAtual > 80 && zoomAtual <= 100) {
                        tamanhoBase = 1820;
                    } else if (zoomAtual > 75 && zoomAtual <= 80) {
                        tamanhoBase = 1850;
                    } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                        tamanhoBase = 1900;
                    } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                        tamanhoBase = 2050;
                    } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                        tamanhoBase = 2450;
                    } else if (zoomAtual < 50) {
                        return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                    }

                    if (zoomAtual > 100 && zoomAtual <= 110) {
                        tamanhoBase = 1850;
                    } else if (zoomAtual > 110 && zoomAtual <= 125) {
                        tamanhoBase = 1870;
                    } else if (zoomAtual > 125 && zoomAtual <= 150) {
                        tamanhoBase = 2500;
                    } else if (zoomAtual > 150 && zoomAtual <= 175) {
                        tamanhoBase = 4900;
                    } else if (zoomAtual > 175) {
                        return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                    }
                }
                return tamanhoBase;
            };

            const calcularWidthTabela = ({ el, zoom = 0.85, desconto = 0 }) => {
                el.style.zoom = 1 * (zoom / 1); // ajusta de verdade o tamanho do elemento
                if (window.innerWidth < 768) {
                    el.style.fontSize = "0.7rem";
                    el.style.width = 1500 - desconto + "px";
                } else {
                    el.style.width = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
                }
            };

            const formatarTabela = ({ el, zoom, heightCelula }) => {
                if (el) {
                    calcularWidthTabela({ el, zoom });
                    el.style.margin = "0 auto";
                    el.style.color = "#FFFFFF";
                    el.style.backgroundColor = "#30303d";
                    el.style.paddingTop = "50px";
                    el.style.paddingBottom = "50px";
                    el.style.borderCollapse = "collapse";
                    el.style.border = "1px solid #666682";

                    // Aplica bordas também às células (th, td)
                    const celulas = el.querySelectorAll("th, td");
                    celulas.forEach((celula) => {
                        if (heightCelula) {
                            celula.style.height = heightCelula;
                        }
                        celula.style.border = "1px solid #666682";
                        celula.style.padding = "8px"; // Adiciona padding para melhorar a aparência
                        celula.style.textAlign = "left";

                        // Remove botões dentro do próprio td (fora da div filha)
                        celula.querySelectorAll("button").forEach((btn) => btn.remove());
                    });
                }
            };

            const quebrarTabelaPorQuantidadeLinhas = ({ tabela, quantidadeLinhasPorPagina = 32 }) => {
                if (!tabela) {
                    return [];
                }

                const linhas = Array.from(tabela.querySelectorAll("tbody > tr"));
                if (linhas.length <= quantidadeLinhasPorPagina) {
                    return [tabela.outerHTML];
                }

                const tabelas = [];
                for (let indice = 0; indice < linhas.length; indice += quantidadeLinhasPorPagina) {
                    const tabelaPagina = tabela.cloneNode(true);
                    const tbodyPagina = tabelaPagina.querySelector("tbody");

                    if (!tbodyPagina) {
                        return [tabela.outerHTML];
                    }

                    while (tbodyPagina.firstChild) {
                        tbodyPagina.removeChild(tbodyPagina.firstChild);
                    }

                    linhas.slice(indice, indice + quantidadeLinhasPorPagina).forEach((linha) => {
                        tbodyPagina.appendChild(linha.cloneNode(true));
                    });

                    tabelas.push(tabelaPagina.outerHTML);
                }

                return tabelas;
            };

            const exibirTagOculta = ({ el, textAlign = "left", zoom, titulo = false }) => {
                if (el) {
                    calcularWidthTabela({ el, zoom });
                    el.style.margin = "0 auto";
                    el.style.color = "#FFFFFF";
                    el.style.fontSize = titulo ? "1.6rem" : "1rem";
                    el.style.lineHeight = "1rem";
                    el.style.fontWeight = "bold";
                    el.style.visibility = "visible";
                    el.style.textAlign = textAlign;
                }
            };

            props.setAguardando(true);
            if (contentCardRef.current) {
                const tabelaContratos = contentCardRef.current.querySelector("#tabela-contratos-demanda");
                const tituloComAbas = contentCardRef.current.querySelector("#titulo-com-abas");
                formatarTabela({ el: tabelaContratos});
                exibirTagOculta({ el: tituloComAbas, titulo: true, textAlign: "center" });


            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="border: 1px solid #DDD; font-family: Arial, sans-serif;"><div style="width:100%; height:8.5%;">
                    <img src="${base64Cabecalho}" width="100%" />
                </div>`;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `<div style="width:100%; height:3%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                            <img src="${base64Rodape}" width="100%" />
                        </div>
                    </div> `;

                const tabelasContratos = quebrarTabelaPorQuantidadeLinhas({ tabela: tabelaContratos, quantidadeLinhasPorPagina: 32 });
                const htmlTabelaContratos =
                    tituloComAbas && tabelasContratos.length
                        ? tabelasContratos.map(
                              (htmlTabela) =>
                                  htmlCabecalho +
                                  `<div style="width:100%; height:84%; background-color:#30303d">` +
                                  tituloComAbas.outerHTML +
                                  htmlTabela +
                                  "</div>" +
                                  htmlRodape
                          )
                        : [];

                // Combina o HTML atualizado dos três elementos
                let html = htmlTabelaContratos.join("");
                // Gera o relatório com o HTML atualizado
                await props.gerarRelatorio({
                    html,
                    landscape: false,
                    scale: window.innerWidth < 768 ? 0.45 : window.devicePixelRatio * 0.45,
                });
                props.setAguardando(false);
            } else {
                console.error("ContentCard não está acessível.");
            }
        } catch (error) {
            console.error("Erro ao gerar o relatório:", error);
        } finally {
            props.setAguardando(false);
            propsExport.callback && propsExport.callback();
        }
    }
}

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    filtro: state.dashboard.filtro,
    aguardando: state.dashboard.aguardando,
    listaDemandaContagem: state.dashboard.listaDemandaContagem,
    listaGraficoCustoAnual: state.dashboard.listaGraficoCustoAnual,
    listaGraficoCustoUnidadeUltimoMes: state.dashboard.listaGraficoCustoUnidadeUltimoMes,
    listaConsumoPercentualPorHorarioUltimoMes: state.dashboard.listaConsumoPercentualPorHorarioUltimoMes,
    listaGraficoCustoPorUnidadeAcumuladoAno: state.dashboard.listaGraficoCustoPorUnidadeAcumuladoAno,
    listaCliente: state.dashboard.listaCliente,
    listaDemandaContratoTipo: state.dashboard.listaDemandaContratoTipo,
    listaUnidadeConsumidora: state.dashboard.listaUnidadeConsumidora,
    listaMesBase: state.dashboard.listaMesBase,
    totalFaturasImportadas: state.fatura.totalFaturasImportadas,
    totalUsuarios: state.usuario.totalUsuarios,
    logados: state.usuario.logados,
    listaLogados: state.usuario.listaLogados,
    pdf: state.displayPDF.pdf,
    nomePdf: state.displayPDF.nomePdf,
    listaEmpresa: state.empresa.listaSelect,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setFiltro,
            carregarGraficos,
            getDemanda,
            getDemandaContagem,
            getListaCliente,
            getTotalFaturasImportadas,
            getTotalUsuarios,
            getLogados,
            getListaUnidadeConsumidora,
            getListaDemandaContratoTipo,
            buscarPdf,
            setArquivoPDF,
            excluirAgendamento,
            excluirPeriodoTeste,
            setPeriodoTesteVisualizado,
            getListaEmpresa,
            setAguardando,
            gerarRelatorio,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
